export default __webpack_public_path__ + "static/features-link-icon4.url-6eff8043ebea3bd6bd37916d7d940564.svg";